import { Box } from "@mui/material";
import React, { useState } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import api from "../../api/axiosInstance";
import { ACCOUNT_INITIAL_VALUES } from "../../data/accounts";
import { AccountListProps, AccountProps, PaginationProps } from "../../typings";
import AccountsTable from "./AccountsTable";
import CreateAccountModal from "./CreateAccountModal";

const MySwal = withReactContent(Swal);
const columns = [
  { id: "id", label: "ID", minWidth: 100 },
  { id: "account_title", label: "Account Title", minWidth: 200 },
  { id: "is_system_generated", label: "System Generated", minWidth: 100 },
];

type AccountsListProps = {
  accounts: AccountListProps[];
  pagination: PaginationProps;
  onPageChange: (e: unknown, page: number) => void;
  onRowsPerPageChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const AccountsList: React.FC<AccountsListProps> = ({ accounts, pagination, onPageChange, onRowsPerPageChange }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const [accountDetails, setAccountDetails] = useState<AccountProps>(
    ACCOUNT_INITIAL_VALUES
  );

  const handleEdit = (account: AccountProps) => {
    setAccountDetails(account);
    handleOpenModal();
  };

  const handleDelete = (account: AccountProps) => {
    MySwal.fire({
      title: "Are you sure?",
      html: `
        <div style="text-align: left; margin-bottom: 1rem;">
          <p>You are about to delete the following account:</p>
          <div style="background-color: #f8f9fa; padding: 1rem; border-radius: 8px; margin-top: 1rem;">
            <p><strong>Account Title:</strong> ${account.account_title}</p>
          </div>
        </div>
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
      reverseButtons: true,
      focusCancel: true,
      showClass: {
        popup: "animate__animated animate__fadeIn animate__faster",
      },
      hideClass: {
        popup: "animate__animated animate__fadeOut animate__faster",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        console.log("Deleting account:", account);
        api
          .delete(`/accounts/${account.id}/`)
          .then(() => {
            MySwal.fire({
              title: "Deleted!",
              text: `${account.account_title} has been deleted.`,
              icon: "success",
              timer: 2000,
              showConfirmButton: false,
            });
          })
          .catch((error) => {
            console.error("Error deleting account:", error);
            MySwal.fire({
              title: "Error!",
              text: "There was an error deleting the account.",
              icon: "error",
            });
          });
      }
    });
  };

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <AccountsTable
        columns={columns}
        data={accounts}
        onEdit={handleEdit}
        onDelete={handleDelete}
        pagination={pagination}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
      />
      <CreateAccountModal
        open={isModalOpen}
        onClose={handleCloseModal}
        account={accountDetails}
      />
    </Box>
  );
};

export default AccountsList;
